import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Avatar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faRotateRight } from '@fortawesome/free-solid-svg-icons';
import ServiceCalls from '../utils/serviceCalls.js';
export default class OMSMailIndicator extends Component {
    constructor(props) {
        super(props);
        this.determineCount = this.determineCount.bind(this);
        this.handleUnreadMessageCount = this.handleUnreadMessageCount.bind(this);
        this.startPolling = this.startPolling.bind(this);
        this.stopPolling = this.stopPolling.bind(this);

        this.unreadMessageHandler = this.handleUnreadMessageCount;

        this.state = {
            isLoading: true,
            inboxCount: '',
            pid: 0
        }
    }

    componentDidMount() {
        // Optionally, start polling if props are ready on mount
        const { omsObj } = this.props;
        const widgetProps = omsObj && omsObj.widgetProps;
        const mailbox = widgetProps && widgetProps.mailbox;
        const mid = mailbox && mailbox.mid;
        const intervalCheck = widgetProps && widgetProps.checkMailInterval;
        if (omsObj.hasRendered && typeof intervalCheck === 'number' && mid) {
            console.log(`In componentDidMount - Props are ready. Starting polling  Interval check: ${intervalCheck} Has Rendered: ${omsObj.hasRendered}`);
            document.body.addEventListener('unreadMessageCount', this.unreadMessageHandler);
            this.startPolling(intervalCheck);
        }
    }

    componentDidUpdate(prevProps) {
        const { omsObj } = this.props;
        const widgetProps = omsObj && omsObj.widgetProps;
        const mailbox = widgetProps && widgetProps.mailbox;
        const mid = mailbox && mailbox.mid;
        const intervalCheck = widgetProps && widgetProps.checkMailInterval;

        // Only restart polling if relevant props change
        if (
            omsObj.hasRendered &&
            typeof intervalCheck === 'number' &&
            mid &&
            JSON.stringify(prevProps.omsObj) !== JSON.stringify(omsObj)) {
            console.log(`In componentDidUpdate - Props are ready. Starting polling  Interval check: ${intervalCheck} Has Rendered: ${omsObj.hasRendered}`);
            document.body.addEventListener('unreadMessageCount', this.unreadMessageHandler);
            this.stopPolling();
            this.startPolling(intervalCheck);
        }
    }


    componentWillUnmount() {
        console.log(`In componentWillUnmount - Removing listener`);
        document.body.removeEventListener('unreadMessageCount', this.unreadMessageHandler);
        this.stopPolling();
    }

    handleUnreadMessageCount(event) {
        console.log(`In handleUnreadMessageCount - Received unread message count event: ${JSON.stringify(event)}`);
        const unreadCount = (event && event.detail && typeof event.detail.unreadMessageCount !== 'undefined')
            ? event.detail.unreadMessageCount
            : 'na';
        console.log(`In handleUnreadMessageCount - Setting message count: ${unreadCount}`);
        this.setState({ inboxCount: unreadCount });
    }

    startPolling(intervalCheck) {
        const { omsObj } = this.props;
        const widgetProps = omsObj && omsObj.widgetProps;
        const mailbox = widgetProps && widgetProps.mailbox;
        const mid = mailbox && mailbox.mid;
        console.log(`Starting OMS unread mail polling every ${intervalCheck} seconds`);
        const pid = setInterval(() => {
            //call getOMSUnreadCount to get latest count
            console.log(`Calling getOMSUnreadCount in Custom Event`);
            ServiceCalls.getOMSUnreadCount(mid).then(unreadCount => {

                var event = new CustomEvent('unreadMessageCount', {
                    detail: {
                        unreadMessageCount: unreadCount
                    }
                });
                document.body.dispatchEvent(event);
            });
        }, intervalCheck * 1000);

        this.setState({
            isLoading: false,
            pid: pid
        });
    }

    stopPolling() {
        if (this.state.pid) {
            console.log(`Stopping OMS unread mail polling for PID ${this.state.pid}`);
            clearInterval(this.state.pid);
            this.setState({ pid: 0 });
        }
    }
    determineCount() {
        var unreadCt = (this.props.omsObj.hasRendered) ? this.state.inboxCount : 0;
        console.log(`In determineCount - Determining unread count: ${unreadCt}`);
        var inboxCt = (isNaN(unreadCt)) ? unreadCt.toString()
            : (unreadCt > 10) ? ' ! ' : unreadCt.toString();
        inboxCt = (inboxCt === '-1') ? 'NA' : inboxCt;
        inboxCt = (inboxCt === '0') ? '' : inboxCt;
        return inboxCt;
    }


    render() {
        const { isLoading, inboxCount } = this.state;
        const msgCounter = (inboxCount) ?
            <span id="inboxCounter" className="fa-layers-counter" data-fa-transform="shrink-11 down-4.2 left-4">{this.determineCount(inboxCount)}</span>
            : <></>;
        if (isLoading) {
            return (<div className="avatarRoleDisplay"> - </div>);
        }
        else if (inboxCount === "REFRESH") {
            return (
                /*  <a href="/Inbox" title="Refresh Inbox">*/
                <Link to="/Inbox" title="Refresh Inbox" reloadDocument={true}>
                    <button title="Refresh Inbox" className="avatar-masthead-button">
                        <span className="fa-layers fa-3x fa-fw">
                            <FontAwesomeIcon id="font-awesome-inbox" transform="shrink-8 down-2 right-1" icon={faEnvelope} />
                            <FontAwesomeIcon icon={faRotateRight} className="fa-thin" transform="shrink-7 up-2" inverse />
                        </span>
                    </button>
                </Link>
                /*  </a>*/
            );
        }
        else {
            return (
                <Link to="/Inbox" title="Contact Payment Services" reloadDocument={true}>
                    <button title="Inbox" className="avatar-masthead-button">
                        <span className="fa-layers fa-3x fa-fw">
                            <FontAwesomeIcon id="font-awesome-inbox" icon={faEnvelope} />
                            {msgCounter}
                        </span>
                    </button>
                </Link>
            );
        }
    }
}